import React, { useEffect } from "react";
import { Container, Row, Col, Form } from "reactstrap";

import { useLocation  } from 'react-router-dom';
import { useState } from "react";
import { loginSuccess } from "src/slices/Auth/Login/reducer";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { setAgency } from "src/slices/thunks";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "src/common/axiosInstance";
import useAgencyData from "../../common/useAgencyData";
const ResetPassword = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        newPassword: "",
        confirmPassword: "",
        activationCode: "",
    });
    const [loading, setLoading] = useState(false);
    const { agencyName, agencyLogo, agencyId, domain } = useAgencyData();
    // Split the URL by `/` and get the last part (which will be the id)
    const pathSegments = location.pathname.split('/');
    const slug = pathSegments[pathSegments.length - 1]; // Get the last segment
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    
    const handleChange = (e: any) => {
        const { id, value } = e.target;
        if (id === "activationCode") {
            // Prevent non-numeric characters
            if (!/^\d*$/.test(value)) {
              return; // Do not populate non-numeric characters
            }
        
            // Stop typing at 6 digits
            if (value.length > 6) {
              return; // Prevent typing more than 6 digits
            }
          }
        
        setFormData((prevFormData) => ({
          ...prevFormData,
          [id]: value,
        }));
    
        validateField(id, value);
    };
    
    const validateField = (field: any, value: any) => {
        let error = "";
    
        if (field === "newPassword") {
          if (!value) {
            error = "Please enter a password.";
          } else if (value.length < 14) {
            error = "Your password must be at least 14 characters long.";
          } else if (!/[A-Z]/.test(value)) {
            error = "Your password must contain at least one uppercase letter.";
          } else if (!/[a-z]/.test(value)) {
            error = "Your password must contain at least one lowercase letter.";
          } else if (!/\d/.test(value)) {
            error = "Your password must include at least one number.";
          } else if (!/[@$!%*?&]/.test(value)) {
            error = "Your password must include at least one special character (e.g., !, @, #, $, %)";
          }
        }
    
        if (field === "confirmPassword") {
          if (!value) {
            error = "Please confirm your password.";
          } else if (formData.newPassword && value !== formData.newPassword) {
            error = "The passwords you entered do not match. Please try again.";
          }
        }
    
        if (field === "activationCode") {
          if (!value) {
            error = "Please enter the activation code.";
          } else if (!/^\d+$/.test(value)) {
            error = "The activation code must contain only numbers.";
          } else if (value.length < 6) {
            error = "The activation code must be at least 6 digits long.";
          }
        }
    
        setErrors((prevErrors) => ({
          ...prevErrors,
          [field]: error,
        }));
    };
    
    const handleSubmit = async (e: any) => {
        setLoading(true);
        e.preventDefault(); // Prevent default form submission behavior
    
        const newErrors: { newPassword?: string; confirmPassword?: string; activationCode?: string } = {};
        
        if (!formData.newPassword) {
            setLoading(false);
            newErrors.newPassword = "Please enter a password.";
        }
        if (!formData.confirmPassword) {
            setLoading(false);
            newErrors.confirmPassword = "Please confirm your password.";
        }
        if ( (formData.newPassword && formData.confirmPassword) && 
            formData.newPassword !== formData.confirmPassword) {
            setLoading(false);
            newErrors.confirmPassword = "The passwords you entered do not match. Please try again.";
        }
        if (!formData.activationCode) {
            setLoading(false);
            newErrors.activationCode = "Please enter the activation code.";
        }
    
        setErrors(newErrors);
    
        if (Object.keys(newErrors).length === 0) {
            try {
              const response = await axiosInstance.post(`/set-password`,{ ...formData, slug,agencyId }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    }
                });
                
                if(!response.data.data.login_data){
                    if(response.data.data.status){
                        toast.success("Password set successfully!");
                        setTimeout(()=> {
                          setLoading(false);
                          navigate("/login");    
                        },2000);
                    } else {
                        setLoading(false);
                        toast.error(response.data.data.msg);
                    }
                } else {
                    if(response.data.data.status){
                        toast.success("Invitation Accepted successfully!");
                        setTimeout(()=> {
                          setLoading(false);
                          localStorage.setItem("authUser", JSON.stringify(response.data.data.login_data));
                          dispatch(loginSuccess(response.data.data.login_data));
                          dispatch(setAgency({"agency_id" : agencyId},navigate,true));    
                        },2000);
                    } else {
                        setLoading(false);
                        toast.error(response.data.msg);
                    }
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching agency data:', error);
            }
        }
    };
    return (
        <React.Fragment>
            <ToastContainer />
            <div className="authentication-bg min-vh-100">
                <div className="bg-overlay bg-white"></div>
                <Container>
                    <div className="d-flex flex-column min-vh-100 px-3 pt-4">
                        <Row className=" justify-content-center my-auto">
                            <Col md={8} lg={6} xl={4}>

                                <div className="text-center py-5">
                                    <div className="mb-4 ">
                                        <Link to="/sales" className="d-block auth-logo">
                                          <img
                                            src={agencyLogo}
                                            alt=""
                                            height="22"
                                            className="auth-logo-dark"
                                            style={{ height: '60px', width: '60px', borderRadius: '50%' }}
                                          />
                                        </Link>
                                    </div>
                                    <p>{agencyName}</p>
                                    <div className="text-muted mb-4">
                                        <h5 className="">Create Password</h5>
                                    </div>
                                    
                                    <Form onSubmit={handleSubmit}>
                                        <div className="form-floating form-floating-custom text-start mb-3">
                                            <input
                                            type="password"
                                            className="form-control"
                                            id="newPassword" // Matches the key in formData
                                            placeholder="Password"
                                            value={formData.newPassword}
                                            onChange={handleChange}
                                            />
                                            <label htmlFor="newPassword">New Password</label>
                                            <div className="form-floating-icon">
                                            <i className="uil uil-padlock"></i>
                                            </div>
                                            {errors.newPassword && (
                                            <small className="text-danger">{errors.newPassword}</small>
                                            )}
                                        </div>

                                        <div className="form-floating form-floating-custom text-start mb-3">
                                            <input
                                            type="password"
                                            className="form-control"
                                            id="confirmPassword" // Matches the key in formData
                                            placeholder="Confirm Password"
                                            value={formData.confirmPassword}
                                            onChange={handleChange}
                                            />
                                            <label htmlFor="confirmPassword">Confirm Password</label>
                                            <div className="form-floating-icon">
                                            <i className="uil uil-check-circle"></i>
                                            </div>
                                            {errors.confirmPassword && (
                                            <small className="text-danger">{errors.confirmPassword}</small>
                                            )}
                                        </div>

                                        <div className="form-floating form-floating-custom text-start mb-3">
                                            <input
                                            type="text"
                                            className="form-control"
                                            id="activationCode" // Matches the key in formData
                                            placeholder= {agencyId ? "Activation Code" : "Add pin"}
                                            value={formData.activationCode}
                                            onChange={handleChange}
                                            />
                                            <label htmlFor="activationCode">{agencyId ? "Activation Code" : "Add pin"}</label>
                                            <div className="form-floating-icon">
                                            <i className="uil uil-clipboard-notes"></i>
                                            </div>
                                            {errors.activationCode && (
                                            <small className="text-danger">{errors.activationCode}</small>
                                            )}
                                        </div>

                                        <div className="mt-3">
                                            <button
                                            className="btn btn-info w-100"
                                            type="submit"
                                            disabled={loading}
                                            >
                                                {loading ? (
                                                  <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                  "Create Password"
                                                )}
                                            </button>
                                        </div>
                                    </Form>
                                    <div className="mt-5 text-center text-muted">
                                        <p>Remember It ? <Link to="/login" className="fw-medium text-decoration-underline"> Sign In </Link></p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default ResetPassword;
